// extracted by mini-css-extract-plugin
export default {"container":"styles_container__nDqvg","main":"styles_main__ufDBE","text":"styles_text__Y8mCJ","holder":"styles_holder__a-qTL"};